import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { FaIcon } from 'components/Icons';
import { HideDomElements } from 'components/misc/globalStyles';
import { useGlobalProps } from 'providers/global-props';
import ButtonAction from 'containers/Attachments/Item/Component/Action';
import Card from './styles';
import theme from 'newJs/config/theme';

const ButtonPrint = (props) => (
    <ButtonAction onClick={() => window.print()} {...props}>
        <FaIcon name='FaPrint' />
    </ButtonAction>
);

const PreviewContent = ({ content, onClose, ...otherProps }) => {
    const { i18n } = useGlobalProps();

    return (
        <ThemeProvider theme={theme}>
            {/* FIXME theme is prop is added only because it is required */}
            <HideDomElements />
            <Card onClose={onClose} {...otherProps}>
                <Card.Header buttons={<ButtonPrint />}>
                    <Card.Title>{i18n.printPreview}</Card.Title>
                </Card.Header>
                <Card.Body className='print-preview-body'>
                    {content}
                </Card.Body>
            </Card>
        </ThemeProvider>
    );
};

PreviewContent.propTypes = {
    content: PropTypes.element,
    onClose: PropTypes.func,
};

export default PreviewContent;
